import axios from "axios";

export const uploadToCloudinary = async (file) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("upload_preset", "chat_upload"); // 👈 твой preset

  try {
    const res = await axios.post(
      "https://api.cloudinary.com/v1_1/dwdmfreoc/image/upload",
      formData
    );

    console.log("UPLOADED:", res.data.secure_url);

    return res.data.secure_url;
  } catch (err) {
    console.log("CLOUDINARY ERROR:", err.response?.data);
    alert("Ошибка загрузки (Cloudinary)");
    return null;
  }
};